import React, { Component } from 'react';
/* Components */
import LoadingModal from '../common/loadingModal';

const ModalInfo = props => (
  <div
    data-close="ok"
    onClick={props.handleModal}
    className={props.modal ? `container-modal` : `container-modal hide`}
  >
    <section className="module-title modal-title">
      <h2>{props.language.account.homologationDriver.vehicules}</h2>
      <a>
        <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
      </a>
      {props.statusSave == 500 && (
        <p className="error">{props.language.error[`cod${props.dataSave.error.code}`]} </p>
      )}
    </section>
    {props.statusSave == 500 && (
      <div className={`box-modal max500 bottom`}>
        <section className="module-table top">
          <table className="fixed">
            <thead>
              <tr>
                <th className="th30">{props.language.account.homologationDriver.code}</th>
                <th className="th30">{props.language.account.homologationDriver.source}</th>
                <th className="th30">{props.language.account.homologationDriver.type}</th>
                <th>{props.language.account.homologationDriver.detail}</th>
              </tr>
            </thead>
            <tbody>
              {props.dataSave.error.params.map((item, i) => {
                const index = props.datos
                  .map(function(e) {
                    return e.id;
                  })
                  .indexOf(parseInt(item.linkBackId, 10));
                return (
                  <tr key={i}>
                    <td className="borde">{index >= 0 ? props.datos[index].dataSource : ''}</td>
                    <td className="borde">
                      {index >= 0 ? props.datos[index].externalEntityId : ''}
                    </td>
                    <td className="borde center red">{item.messageType}</td>
                    <td className="borde">{props.language.error[`cod${item.messageCode}`]}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>
      </div>
    )}
    {props.statusSave == 200 && (
      <div className={`box-modal max500`}>
        <section className={'feed-back green'}>
          <div>
            <i className="fas fa-check-circle" />
          </div>
          <div>
            <p>{props.language.account.homologationDriver.teamCreateSuccess}</p>
          </div>
        </section>
      </div>
    )}
  </div>
);

export default ModalInfo;



// WEBPACK FOOTER //
// ./source/client/components/homologation_vehicle/modalInfo.jsx